import "daterangepicker/daterangepicker.css";

import React, { useState } from "react";
import { useEffect } from "react";
import { Line } from "react-chartjs-2";
// import { CreatorDashboardApi } from "../services/api";
import { makeAPI } from "../../services/api";
import {
    Chart as ChartJS,
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip,
} from "chart.js";

ChartJS.register(
    LineElement,
    CategoryScale,
    LinearScale,
    PointElement,
    Tooltip
);

let dateRangePluginReady = false;

async function ensureDateRangeDependencies() {
    const [{ default: momentLib }, { default: jqueryLib }] = await Promise.all([
        import("moment"),
        import("jquery"),
    ]);

    const jq = window.jQuery || window.$ || jqueryLib;
    const m = window.moment || momentLib;

    window.$ = jq;
    window.jQuery = jq;
    window.moment = m;

    if (!dateRangePluginReady || !jq?.fn?.daterangepicker) {
        await import("daterangepicker");
        dateRangePluginReady = true;
    }

    return { $: jq, moment: m };
}



const CreatorDashboard = () => {
    const [account_status, setAccountStatus] = React.useState("Active"); // Possible values: Active, Paused, Suspended
    const [creator_code, setCreatorCode] = React.useState("");
    const [creator_name, setCreatorName] = React.useState("");
    const [total_supporters, setTotalSupporters] = React.useState(0);
    const [total_coins, setTotalCoins] = React.useState(18450);
    const [active_supporters, setActiveSupporters] = React.useState(0);
    const [coins_earned_today, setCoinsEarnedToday] = React.useState(0);
    const [coins_earned_month, setCoinsEarnedMonth] = React.useState(0);
    const [earnings_from_tournaments, setEarningsFromTournaments] = React.useState(0);
    const [earnings_from_shop, setEarningsFromShop] = React.useState(0);
    const [recent_active_supporters, setRecentActiveSupporters] = React.useState(0);
    const [recent_matches_played, setRecentMatchesPlayed] = React.useState(0);
    const [creator_tier, setCreatorTier] = React.useState("Gold");
    const [next_goal, setNextGoal] = React.useState(10); // in supporters
    const [reward_rate, setRewardRate] = React.useState(3); // in percentage
    //Chart Data & Options
    // const [chart_labels, setChartLabels] = React.useState(["Jan-2025", "Feb-2025", "Mar-2025", "Apr-2025", "May-2025", "Jun-2025", "Jul-2025", "Aug-2025", "Sep-2025", "Oct-2025", "Nov-2025", "Dec-2025"]);
    // const [chart_values, setChartValues] = React.useState([120, 420, 150, 300, 260, 340, 420, 500, 480, 520, 600, 580, 620, 700, 680, 720, 800, 780, 820, 900, 880, 920, 1000, 980, 1020, 1100, 1080, 1120, 1200, 1180, 1250, 1300]);
    const [chart_labels, setChartLabels] = React.useState([]);
    const [chart_values, setChartValues] = React.useState([]);

    const chartData = {
        labels: chart_labels,
        datasets: [
            {
                data: chart_values,
                borderColor: "#ff810e",
                pointBackgroundColor: "#ff810e",
                pointStyle: "rectRounded",
                tension: 0.45,
            },
        ],
    };

    const hasData = chartData?.datasets?.[0]?.data?.some(v => v > 0);

    const chartOptions = {
        plugins: { legend: { display: false }, noData: true, },
        scales: {
            x: { ticks: { color: "#aaa" }, grid: { display: false } },
            y: { ticks: { color: "#aaa" }, grid: { color: "#222" } },
        },
    };
    const  user  = JSON.parse(localStorage.getItem('user'));
    // Backend API Data's.
    const [server_data, setserver_data] = useState({
        // change dynamically
        "user_id": user?.user_id || "",
        "start_date": "",
        "end_date": "",
        "type": "day",
    })

    useEffect(() => {
        if (user) {
            CreatorApiCall();
        } else {
            //return home
            window.location.pathname = '/'
        }
    }, [server_data.start_date, server_data.end_date, server_data.type]);


    async function CreatorApiCall(params) {
        // alert("Loading Creator Data...");
        try {
            const data = await makeAPI("/api/creator_dashboard","post",false,{data :{...server_data}});
            if (data.status === "S") {
                // Set values to stat
                let value = data.data;
                setCreatorName(value.name);
                setAccountStatus(value.status);
                setActiveSupporters(value.active_supporters);
                setChartLabels(value.graph_data.labels);
                setChartValues(value.graph_data.data);
                setCoinsEarnedMonth(value.coins_earned_month);
                setCoinsEarnedToday(value.coins_earned_today);
                setCreatorCode(value.creator_code);
                setCreatorTier(value.creator_level);
                setEarningsFromShop(value.earning_overview.SHOP || 0);
                setEarningsFromTournaments(value.earning_overview.TOURNAMENT_FEE || 0);
                setNextGoal(value.next_milestone);
                setRecentActiveSupporters(value.recent_activity.new_supporter);
                setRecentMatchesPlayed(value.recent_activity.matches_played);
                setRewardRate(value.reward_rate);
                setTotalCoins(value.total_earned_coins);
                setTotalSupporters(value.total_supporters);
            } else {
                // redirect to another window home.
                window.location.pathname = '/'
            }
        } catch (error) {

        }
    }

    function copy_btn() {
        var copy_text = creator_code;
        navigator.clipboard.writeText(copy_text).then((e) => {
            copiedBtn()
        }).catch((err) => {
            console.log("error", err);
        })
    }

    function copiedBtn() {
        const copy_btn = document.querySelector('.fa-copy');
        if (!copy_btn) return;
        let tooltip_text = document.createElement('span');
        tooltip_text.innerText = 'Copied!';
        tooltip_text.style.position = 'absolute';
        tooltip_text.style.background = '#333';
        tooltip_text.style.color = '#fff';
        tooltip_text.style.padding = '2px 8px';
        tooltip_text.style.borderRadius = '4px';
        tooltip_text.style.fontSize = '12px';
        tooltip_text.style.top = '-28px';
        tooltip_text.style.right = '0';
        tooltip_text.style.zIndex = '1000';
        tooltip_text.className = 'copied-tooltip_text';

        copy_btn.parentElement.style.position = 'relative';
        copy_btn.parentElement.appendChild(tooltip_text);

        setTimeout(() => {
            tooltip_text.remove();
        }, 2000);
    }
    // separate useEffect for daterangepicker
    useEffect(() => {
        if (!user) return;

        let cancelled = false;
        let teardown = null;

        (async () => {
            const { $, moment } = await ensureDateRangeDependencies();
            if (cancelled) return;

            const rangeEl = $('#reportrange');
            if (!rangeEl.length || !$.fn?.daterangepicker) return;

            const existingPicker = rangeEl.data('daterangepicker');
            if (existingPicker) existingPicker.remove();

            const start = moment().subtract(6, 'days');
            const end = moment();

            const cb = (cbStart, cbEnd) => {
                $('#reportrange span').html(
                    cbStart.format('MMMM D, YYYY') + ' - ' + cbEnd.format('MMMM D, YYYY')
                );
            };

            rangeEl.daterangepicker({
                autoUpdateInput: false,
                startDate: start,
                endDate: end,
                maxDate: moment(),
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [
                        moment().subtract(1, 'month').startOf('month'),
                        moment().subtract(1, 'month').endOf('month')
                    ]
                }
            }, cb);

            cb(start, end);

            rangeEl.on('apply.daterangepicker', (ev, picker) => {
                const day_count = picker.endDate.diff(picker.startDate, 'days') + 1;
                const type =
                    picker.chosenLabel === 'Custom Range' && day_count > 31
                        ? 'month'
                        : 'day';

                setserver_data(prev => ({
                    ...prev,
                    start_date: picker.startDate.format('YYYY-MM-DD'),
                    end_date: picker.endDate.format('YYYY-MM-DD'),
                    type
                }));

                cb(picker.startDate, picker.endDate);
            });

            rangeEl.css({
                'background': 'var(--card-bg)',
                'cursor': 'pointer',
                'padding': '8px 7px',
                'border-radius': '8px',
                'width': 'fit-content',
                'color': 'var(--accent)',
            });

            rangeEl.addClass('glass-card');

            teardown = () => {
                const picker = rangeEl.data('daterangepicker');
                if (picker) picker.remove();
                rangeEl.off('apply.daterangepicker');
            };
        })();

        return () => {
            cancelled = true;
            if (teardown) teardown();
        };
    }, [user]);

    function enablePreloader() {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.visibility = "visible";
            preloader.style.opacity = "1";
        }
    }

    function disablePreloader() {
        const preloader = document.getElementById("preloader");
        if (preloader) {
            preloader.style.opacity = "0";
            setTimeout(() => {
                preloader.style.visibility = "hidden";
            }, 1000);
        }
    }
    return (
        <>
            {/* Inline CSS */}
            <style>{`
        :root {
          --accent: #fff;
          --card-bg: rgba(20, 20, 20, 0.8);
        }

        .text-secondary {
          color: #aaa !important;
        }

        .creator-admin-page i {
          color: #ff810e !important;
        }

        .glass-card {
            padding: 30px;
          background: var(--card-bg);
          backdrop-filter: blur(14px);
          border-radius: 10px;
          transition: all 0.25s ease;
        }

        .glass-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 0 18px rgba(255, 129, 14, 0.3);
        }

        .text-accent {
          color: var(--accent);
        }

        .btn-accent {
          background: var(--accent);
          color: #000;
          border: none;
          border-radius: 30px;
          padding: 8px 18px;
          font-weight: 600;
        }

        .btn-accent:hover {
          box-shadow: 0 0 12px rgba(255, 129, 14, 0.6);
        }

        .fade-in {
          animation: fadeIn 0.6s ease;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
          .daterangepicker {
  background-color: rgba(20, 20, 20, 0.8) !important;
  border: 1px solid #1e293b;
  color: #ff810e;
}

.daterangepicker .calendar-table {
  background-color: #161616 !important;
}

.daterangepicker td.available:hover {
  background-color: #ff810e !important;
}

.daterangepicker td.active {
  background-color: #ff810e !important;
  color: white;
}
.daterangepicker td.off {
    background-color: #161616 !important;
    color: #ff810e;
}
.daterangepicker td.in-range {
    background-color: #ff810e !important;
}
.daterangepicker .cancelBtn{
    background-color: #ff810e !important;
    height: auto !important;
    line-height: normal !important;
    padding: auto !important;
    color: #fff;
}
.daterangepicker .applyBtn{
    background-color: #ff810e !important;
    height: auto !important;
    line-height: normal !important;
    padding: auto !important;
    color: #fff;
}
.daterangepicker .calendar-table .next span, .daterangepicker .calendar-table .prev span {
  /* color: red !important; */
  border: solid #ff810e !important;
  background-color: #ff810e !important;
  padding: 1px !important;
}
.daterangepicker .ranges li:hover {
  background-color: #141414 !important;
}

.daterangepicker .ranges li.active {
  background-color: #ff810e !important;
  color: #fff !important;
}
      `}</style>

            <div className="min-vh-100 pd-top-120 pd-bottom-90 creator-admin-page">
                <div className="container text-light fade-in">

                    {/* Header */}

                    {/* Top Full Stretch Card */}
                    <div className="p-3 mb-4">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">

                            {/* Left */}
                            <div>
                                <h4 className="fw-bold mb-0">
                                    <i className="fa-solid fa-user-gear text-accent me-2" />
                                    Creator Dashboard
                                </h4>
                                <div className="text-secondary">
                                    Manage your supporters & earnings.
                                </div>
                                <div style={{ color: "#ff810e" }}>
                                    {creator_name?.toUpperCase()}
                                </div>
                            </div>

                            {/* Right */}
                            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3">

                                {/* Creator Code */}
                                <div className="text-md-start">
                                    <div className="text-secondary mb-1">
                                        Your Creator Code: &nbsp;&nbsp;
                                        <span className={`badge ${account_status === "Active" ? "bg-success" : account_status === "Paused" ? "bg-warning" : "bg-danger"}`}>
                                            {account_status}
                                        </span>
                                    </div>

                                    <div
                                        className="d-flex align-items-center justify-content-center gap-3 px-4 py-2"
                                        style={{
                                            border: "1px solid #ff810e",
                                            borderRadius: "14px",
                                            minHeight: "56px",
                                        }}
                                    >
                                        <span className="fw-bold text-accent fa-2x">
                                            {creator_code?.toUpperCase()}
                                        </span>

                                        <i
                                            className="fa-solid fa-copy fa-2x text-accent"
                                            role="button"
                                            title="Copy Creator Code"
                                            style={{ cursor: "pointer" }}
                                            onClick={copy_btn}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Data Range Picker */}
                    
                    <label>Choose Period:</label>
                    <div id="reportrange" >&nbsp;<i className="fa fa-calendar"></i>&nbsp;&nbsp;<span></span> <i className="fa fa-caret-down"></i>
                    </div> 
                    <br />

                    {/* Stats */}
                    <div className="row g-3">
                        <Stat icon="fa-users" label="Total Supporters" value={total_supporters ||0} column="col-md-4" />
                        <Stat icon="fa-coins" label="Total Coins" value={total_coins ||0} column="col-md-4" />
                        <Stat icon="fa-user-check" label="Active Supporters" value={active_supporters ||0} column="col-md-4" />
                    </div>

                    <div className="row g-3 mt-1">
                        <Stat icon="fa-arrow-trend-up" label="Coins Earned Today" value={coins_earned_today ||0} column="col-md-6" />
                        <Stat icon="fa-calendar-days" label="Coins Earned This Month" value={coins_earned_month ||0} column="col-md-6" />
                    </div>

                    {/* Chart */}
                    <div className="glass-card p-3 mt-4">
                        <div className="text-secondary mb-2">
                            <i className="fa-solid fa-chart-line text-accent me-2" />
                            Earnings Trend (7 Days)
                        </div>

                        {hasData ? (
                            <Line data={chartData} options={chartOptions} height={80} />
                        ) : (
                            <div className="d-flex flex-column justify-content-center align-items-center h-100 text-secondary">
                                <i className="fa-solid fa-chart-simple fa-2x mb-2" />
                                <div>No data available</div>
                                <small>Share your creator code to start earning</small>
                            </div>
                        )}
                    </div>
                    <div className="row g-3 mt-4">

                        {/* Earnings Overview – Left (6 col) */}
                        <div className="col-12 col-md-6">
                            <div className="glass-card p-3 h-100">
                                <div className="text-secondary mb-3">
                                    <i className="fa-solid fa-coins text-accent me-2" />
                                    Earnings Overview
                                </div>

                                <div className="d-flex justify-content-between mb-3">
                                    <span className="text-secondary">From Tournaments</span>
                                    <span className="fw-bold text-accent">{earnings_from_tournaments ||0} coins</span>
                                </div>

                                <div className="d-flex justify-content-between mb-3">
                                    <span className="text-secondary">From Shop Redeemptoin</span>
                                    <span className="fw-bold text-accent">{earnings_from_shop ||0} coins</span>
                                </div>

                                <hr className="border-secondary opacity-25" />

                                <div className="d-flex justify-content-between">
                                    <span className="fw-bold">Total Earnings</span>
                                    <span className="fw-bold fs-5 text-accent">
                                        {earnings_from_tournaments + earnings_from_shop || 0} coins
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Recent Activity – Right (6 col) */}
                        <div className="col-12 col-md-6">
                            <div className="glass-card p-3 h-100">
                                <div className="text-secondary mb-3">
                                    <i className="fa-solid fa-clock-rotate-left text-accent me-2" />
                                    Recent Activity (Last 7 Days)
                                </div>

                                <div className="d-flex justify-content-between mb-3">
                                    <div className="d-flex align-items-center">
                                        <i className="fa-solid fa-users text-accent me-2" />
                                        <span className="text-secondary">New Supporters</span>
                                    </div>
                                    <span className="fw-bold">+{recent_active_supporters||0}</span>
                                </div>

                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <i className="fa-solid fa-gamepad text-accent me-2" />
                                        <span className="text-secondary">Total Players Played</span>
                                    </div>
                                    <span className="fw-bold">+{recent_matches_played||0}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Info */}
                    <div className="row g-3 mt-4">
                        <Info icon="fa-percent" title="Reward Rate" value={`${reward_rate}% per supporter spend`} />
                        <Info icon="fa-medal" title="Creator Tier" value={creator_tier} accent />
                        <Info icon="fa-flag-checkered" title="Next Goal" value={`${next_goal <= 5000 ? next_goal + " supporters" : "You Reached Max Tier"}`} />
                    </div>

                    <div className="text-center text-secondary small mt-3">
                        <i className="fa-regular fa-clock me-1" />
                        Last updated just now
                    </div>
                </div>
            </div>
        </>
    );
};


export default CreatorDashboard;

/* Sub Components */

const Stat = ({ icon, label, value, column }) => (
    <div className={`col-12 ${column}`}>
        <div className="glass-card h-100">
            <div className="d-flex align-items-center">
                <i className={`fa-solid ${icon} fa-2x text-accent me-3`} />
                <div>
                    <div className="text-secondary">{label}</div>
                    <div className="fs-4 fw-bold text-accent">{value}</div>
                </div>
            </div>
        </div>
    </div>
);

const Info = ({ icon, title, value, accent }) => (
    <div className="col-12 col-md-4">
        <div className="glass-card p-3 h-100">
            <div className="text-secondary small mb-1">
                <i className={`fa-solid ${icon} me-1`} />
                {title}
            </div>
            <div className={`fw-bold ${accent ? "text-accent fs-5" : ""}`}>
                {value}
            </div>
        </div>
    </div>
);
